import React, { Component } from "react";
import uniqueId from "lodash/uniqueId";
import Aculistc3 from "c3/c3.js";
import { selection } from "d3-selection";
import * as d3format from "d3-format";
import { labels, legendlabels } from "./labels.js";
import html2canvas from "./localHtml2Canvas.js";
//import * as Canvas2Image from "./canvastoimage.js";
//import domtoimage from './dom2image.js';
import "c3/c3.css";
import style from "./css/charts.css";
import Promise from 'promise-polyfill';

window.html2canvas = html2canvas;
//window.Canvas2Image = Canvas2Image;
//window.jquery=$;
// import Share from './share.js';
const logo = require("./images/aculist-edge_logo.png");
const download = require("./images/download.png");

export default class MarketTrends extends Component {
  constructor(props) {
    super(props);
 
    this.state = {
      btncharttypeactive: "",
      chartType: "",
      copyInProgress: false
    };
    this.handleImageClick = this.handleImageClick.bind(this);
    this.copyChart = this.copyChart.bind(this);
  }
  componentWillMount() {  
    
    var chartType = this.props.widgetselections.measure
      .toLowerCase()
      .indexOf("count")>=0
      ? "area"
      : "line";
 
  }

  componentWillReceiveProps(nextProps) {

    var chartType = nextProps.widgetselections.measure
      .toLowerCase()
      .indexOf("count")>=0
      ? "area"
      : "line";

  }

  handleImageClick(e) {
    e.preventDefault();
  
  }

  copyChart(e) {   
    var target=e.target;
    // d3.select(document.getElementById(target.dataset.id)).classed('c3', true);
    document.getElementById(target.dataset.id).classList.add('c3');  
    var doctype = '<?xml version="1.0" standalone="no"?><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">';
    
      window.URL = (window.URL || window.webkitURL);
    
      var body = document.body,
          emptySvg;
    
      var prefix = {
        xmlns: "http://www.w3.org/2000/xmlns/",
        xlink: "http://www.w3.org/1999/xlink",
        svg: "http://www.w3.org/2000/svg"
      };
    var emptySvg = window.document.createElementNS(prefix.svg, 'svg');
    window.document.body.appendChild(emptySvg);

    
    var emptySvgDeclarationComputed = getComputedStyle(emptySvg);
    
    function setInlineStyles(svg, emptySvgDeclarationComputed) {
    
        function explicitlySetStyle (element) {
          var cSSStyleDeclarationComputed = getComputedStyle(element);
          var i, len, key, value;
          var computedStyleStr = "";
          for (i=0, len=cSSStyleDeclarationComputed.length; i<len; i++) {
            key=cSSStyleDeclarationComputed[i];
            value=cSSStyleDeclarationComputed.getPropertyValue(key);
            if (value!==emptySvgDeclarationComputed.getPropertyValue(key)) {
              computedStyleStr+=key+":"+value+";";
            }
          }
          element.setAttribute('style', computedStyleStr);
        }
        function traverse(obj){
          var tree = [];
          tree.push(obj);
          visit(obj);
          function visit(node) {
            if (node && node.hasChildNodes()) {
              var child = node.firstChild;
              while (child) {
                if (child.nodeType === 1 && child.nodeName != 'SCRIPT'){
                  tree.push(child);
                  visit(child);
                }
                child = child.nextSibling;
              }
            }
          }
          return tree;
        }
        // hardcode computed css styles inside svg
        var allElements = traverse(svg);
        var i = allElements.length;
        while (i--){
          explicitlySetStyle(allElements[i]);
        }
      }
    var holder = document.createElement("DIV");
    var canvasHolder = document.createElement("CANVAS");
    canvasHolder.id = "canvasHolder";
    holder.id = "chartCopyHolder";
    document.getElementById("aculistWidgetRoot").querySelector('.markettrends').appendChild(holder);
    document.getElementById("aculistWidgetRoot").querySelector('.markettrends').appendChild(canvasHolder);
    if (!Element.prototype.matches)
      Element.prototype.matches = Element.prototype.msMatchesSelector || 
                                  Element.prototype.webkitMatchesSelector;
    if (!Element.prototype.closest)
      Element.prototype.closest = function(s) {
          var el = this;
          if (!document.documentElement.contains(el)) return null;
          do {
              if (el.matches(s)) return el;
              el = el.parentElement || el.parentNode;
          } while (el !== null && el.nodeType === 1); 
          return null;
      };
    var svg = document.getElementById(target.dataset.id).closest('.titleChartHolder');
    var cln = svg.cloneNode(true);
    document.getElementById("chartCopyHolder").appendChild(cln);
    
    
    setInlineStyles(document.getElementById('chartCopyHolder').getElementsByTagName( 'svg' )[0], emptySvgDeclarationComputed);
    
    html2canvas(document.getElementById('chartCopyHolder'), {
      canvas: document.getElementById('canvasHolder'),
      logging: false,      
      width:document.getElementById('chartCopyHolder').clientWidth+10,
    }).then(function(canvas){
      function convertCanvasToImage(canvas) {
        var image = new Image();
        image.src = canvas.toDataURL("image/png");
        image.crossOrigin="anonymous";
        return image;
      }

      var image = convertCanvasToImage(document.getElementById('canvasHolder'))
      require("./downloadjs.js")(image.src, target.dataset.ctitle.replace(/\s/g, ''), "image/png");

      document.getElementById("aculistWidgetRoot").querySelector('.markettrends').removeChild(holder);
      document.getElementById("aculistWidgetRoot").querySelector('.markettrends').removeChild(canvasHolder);
      
    });

     
  }

  render() {

    let logoStyles = {
      height: '16px',
      width: '72px',
      background: `url(${logo})`
    }   

    if(!_.isUndefined(this.props.data)){

      // Internet Explorer 6-11
      let isIE = /*@cc_on!@*/false || !!document.documentMode;      
          let MTitle=this.props.widgetselections.measure.split(",")[1]===undefined ?labels[this.props.widgetselections.measure.split(",")[0]]:
          labels[this.props.widgetselections.measure.split(",")[0]].toLowerCase().indexOf('price')>=0 && labels[this.props.widgetselections.measure.split(",")[1]].toLowerCase().indexOf('price')>=1?
      "Average & Median Pricing Trends"
        : " & "+  labels[this.props.widgetselections.measure.split(",")[1]];




          let baseTitle= MTitle+' '+' - '+decodeURIComponent(this.props.widgetselections.geo[0].split(":")[1]+' '+this.props.widgetselections.geo[0].split(":")[0]);
        // let baseTitle=labels[this.props.widgetselections.measure.split(",")[0]] +' '+ M2Title 
          let periodTitle=this.props.data[this.props.data.length-1].Year+' - '+ this.props.data[0].Year+' (by '+ this.props.widgetselections.periodtype +')';

          let areaTitle =typeof this.props.data==='undefined' ?"":this.props.data.length==0?'':
          ( this.props.widgetselections.geo[0].split(":")[0] == "Area" && this.props.data[0].AreaId!=null)
              ? "(MLS AREA" + this.props.data[0].AreaId + ")"
              : "";
          return (
            <div className="titleChartHolder">
              {/* <div className="chartShare"><Share divid={this.props.widgetselections.divid}/></div> */}
              <div className={`chartTitle ${this.props.widgetselections.title === 'false' ? "hidden" : ""}`}>
            
              <h3 className="title"> {baseTitle+ areaTitle}</h3> 
            <h3 className="subtitle"> { periodTitle}  </h3>
              </div>
        

              <div key={uniqueId("marketTrendsChart-")} className="section_container">
              <img src={download} className={`copybtn ${this.state.copyInProgress === true || isIE ? "hidden" : "" }`} onClick={this.copyChart} data-id={this.props.id} data-ctitle={baseTitle+ areaTitle}/> 
                <Chart
                  {...this.props}
                  id={this.props.id}
                  data1={this.props.data}
                  widgetselections={this.props.widgetselections}
                  chartType={this.state.chartType}
                />
                <div className={`chartOptionsRow`}>
                  {/* <span className="externalOptions">{this.props.children}</span> */}
                  <span className="d-block attribution-holder clearfix pos-relative">
                    <span className="d-inline-block attribution-label">
                      Powered by:
                    </span>
                    <a
                      href="http://aculist.com/"
                      target="_blank"
                      className="attribution-img" >
                      <span className="d-inline-block logoclass" style={logoStyles}></span>
                      {/* <img src={logo} onClick={this.handleImageClick}/> */}
                    </a>
                  </span>
                </div>
              </div>
            </div>
          );
        } else {
          return(null);
        }
  }
}

class Chart extends React.Component {
  componentDidMount() {

    if(this.props.widgetselections.measure.split(",").length==1)
      {this._updateSingleAxesChart(
        this.props.data1,
        this.props.widgetselections,
        this.props.assets
      );}
    else
      this._updateChart(
        this.props.data1,
        this.props.widgetselections,
        this.props.assets
      );
  }

  componentDidUpdate() {

    if(this.props.widgetselections.measure.split(",").length==1)
      {this._updateSingleAxesChart(
        this.props.data1,
        this.props.widgetselections,
        this.props.assets
      );}
    else   
      this._updateChart(
        this.props.data1,
        this.props.widgetselections,
        this.props.assets
      );
  }

  _updateChart(data1, ws, assets) {
    var measurearray = ws.measure.split(",");
    var masterarray = [];
    var periodarray = [];

    
    var SFarrayM1 = ["SFHM1"];
    var CIarrayM1 = ["C/TM1"];
    var SFarrayM2 = ["SFHM2"];
    var CIarrayM2 = ["C/TM2"];

    var periodarrayasc = [];
    var periodarrayformatted = ["Period"];

    data1.forEach(function(record) {
      if (periodarrayasc.indexOf(record.Period) === -1) {
        periodarrayasc.push(record.Period);
      }
    });
    periodarrayasc.reverse().forEach(function(x) {
      periodarray.push(x);
    });



    periodarray.forEach(function(periodrecord) {
    let filtereddata1=data1.filter(rec=>rec.Period===periodrecord)
  

    filtereddata1.forEach(function(record) { 
      if(filtereddata1.length==2){     
      record.Class.toLowerCase() == "residential - single family" 
          ? SFarrayM1.push(record[measurearray[0].toString()]) && SFarrayM2.push(record[measurearray[1].toString()])
          : record.Class.toLowerCase() == "residential - common interest" 
        //  ? record[measurearray[0].toString()]==null?CIarrayM1.push('0') : CIarrayM1.push(record[measurearray[0].toString()]) &&
         // record[measurearray[1].toString()]==null?CIarrayM2.push('0') : CIarrayM2.push(record[measurearray[1].toString()])
       ? CIarrayM1.push(record[measurearray[0].toString()]==null?0:record[measurearray[0].toString()]) && CIarrayM2.push(record[measurearray[1].toString()]==null?0:record[measurearray[1].toString()])
          //  ? CIarrayM1.push(record[measurearray[0].toString()]) && CIarrayM2.push(record[measurearray[1].toString()])
            : "";
      }else
      {
       
        record.Class.toLowerCase() == "residential - single family" 
        ? SFarrayM1.push(record[measurearray[0].toString()]) && SFarrayM2.push(record[measurearray[1].toString()]) &&
        CIarrayM1.push(null) && CIarrayM2.push(null)
        : record.Class.toLowerCase() == "residential - common interest" 
          ? CIarrayM1.push(record[measurearray[0].toString()]) && CIarrayM2.push(record[measurearray[1].toString()]) &&
          SFarrayM1.push(null) && SFarrayM2.push(null)
          : "";
        
      }
   
      });
  
    
    });
  

    if (ws.periodtype.toLowerCase() == "month") {
      var monthnames = {
        "01": "Jan",
        "02": "Feb",
        "03": "Mar",
        "04": "Apr",
        "05": "May",
        "06": "Jun",
        "07": "Jul",
        "08": "Aug",
        "09": "Sep",
        "10": "Oct",
        "11": "Nov",
        "12": "Dec"
      };
      periodarray.forEach(function(periodraw) {
        periodarrayformatted.push(
          monthnames[periodraw.substring(5)] + " " + periodraw.substring(2, 4)
        );
      });
    } else if (ws.periodtype.toLowerCase() == "quarter") {
      periodarray.forEach(function(periodraw) {     
       /*  periodarrayformatted.push(
          periodraw.substring(4, 6) + " " + periodraw.substring(2, 4)
        ); */
        periodarrayformatted.push(periodraw);
      });
    } else {
      periodarray.forEach(function(periodrecord) {
        periodarrayformatted.push(periodrecord);
      });
    }

    masterarray.push(periodarrayformatted);

    if(this.props.widgetselections.classtype.split(',').length==2 )
      {
        SFarrayM1.length > 1 ? masterarray.push(SFarrayM1) : "";
        CIarrayM1.length > 1 ? masterarray.push(CIarrayM1) : "";
        SFarrayM2.length > 1 ? masterarray.push(SFarrayM2) : "";
        CIarrayM2.length > 1 ? masterarray.push(CIarrayM2) : "";
          }
          else if(this.props.widgetselections.classtype.indexOf('Single Family')>=0)
      {       
        SFarrayM1.length > 1 ? masterarray.push(SFarrayM1) : "";
    SFarrayM2.length > 1 ? masterarray.push(SFarrayM2) : "";}
    else if(this.props.widgetselections.classtype.indexOf('Common Interest')>=0)
      {
        CIarrayM1.length > 1 ? masterarray.push(CIarrayM1) : "";
        CIarrayM2.length > 1 ? masterarray.push(CIarrayM2) : "";
      }
   

    let defaultcolors = [
      "RGB(0,130,202)",
      "RGB(246,178,33)",
      "RGB(255,102,0)",
      "RGB(28,63,148)",
    ];
    //let defaultcolors=[ 'RGB(126,159,26)', 'RGB(230,145,56)','RGB(0,0,0)', 'RGB(255,217,102)']
    let preferredcolors = [];
    // assets
    //   .filter(
    //     prefrow =>
    //       prefrow.AttributeKey.toLowerCase().includes("vprimcolor") ||
    //       prefrow.AttributeKey.toLowerCase().includes("vseccolor")
    //   )
    //   .forEach(function(pref) {
    //     preferredcolors.push(pref.AttributeValue);
    //   });
    // defaultcolors.forEach(function(defcol) {
    //   if (!preferredcolors.includes(defcol)) {
    //     preferredcolors.push(defcol);
    //   }
    // });
    Aculistc3.chart.internal.fn.getHorizontalAxisHeight = function (axisId) {
      var $$ = this, config = $$.config, h = 30;
      if (axisId === 'x' && !config.axis_x_show) { return 8; }
      if (axisId === 'x' && config.axis_x_height) { return config.axis_x_height; }
      if (axisId === 'y' && !config.axis_y_show) { 
          return config.legend_show && !$$.isLegendRight && !$$.isLegendInset ? 10 : 1; 
      }
      if (axisId === 'y2' && !config.axis_y2_show) { return $$.rotated_padding_top; }
      // Calculate x axis height when tick rotated
      if (axisId === 'x' && !config.axis_rotated && config.axis_x_tick_rotate) {
          h = 30 + $$.axis.getMaxTickWidth(axisId) * Math.cos(Math.PI * (90 - Math.abs(config.axis_x_tick_rotate)) / 180);
      }
      // Calculate y axis height when tick rotated
      if (axisId === 'y' && config.axis_rotated && config.axis_y_tick_rotate) {
          h = 30 + $$.axis.getMaxTickWidth(axisId) * Math.cos(Math.PI * (90 - Math.abs(config.axis_y_tick_rotate)) / 180);
      }
      return h + ($$.axis.getLabelPositionById(axisId).isInner ? 0 : 10) + (axisId === 'y2' ? -10 : 0);
  };

    const chart = Aculistc3.generate({
    //  padding: { top: 50, left: 50, bottom: 20 },
      bindto: "#" + this.props.id,
      position: "inset",
   //   padding: {
     //   top: 40
    //  },

      data: {
        types: {
          SFHM2: "line",
          "C/TM2": "line",
          SFHM1: "line",
          "C/TM1": "line"
        },
        x: "Period",
        columns: masterarray,
        axes: {
          SFHM2: "y",
          "C/TM2": "y",
          SFHM1: "y",
          "C/TM1": "y"
        },
        labels: "true",
        names: {
          SFHM1: "Single Family Home " + legendlabels[measurearray[0]],
          "C/TM1": "Condo/Townhome " + legendlabels[measurearray[0]],
          SFHM2: "Single Family Home " + legendlabels[measurearray[1]],
          "C/TM2": "Condo/Townhome " + legendlabels[measurearray[1]]
        }
      },
      point: {
        r: 0
      },
      color: {
        pattern: [
          "RGB(28,63,148)", 
          "RGB(255,102,0)",      
          "RGB(0,130,202)", 
          "RGB(246,178,33)",
         
         
          
        ]
      },
      axis: {
        // y2: {
        //   // padding:10,
        //   tick: {
        //     outer: false,
        //     format:
        //     measurearray[1].toLowerCase().includes("over") 
        //       ? d3format.format(".0%") :measurearray[1].toLowerCase().includes("count") 
        //       ? d3format.format(',')
        //       :measurearray[1].toLowerCase().includes("price") ?d3format.format("$,")
        //       :""
        //   },
        //   show: true,
        //   label: {
        //     text: labels[measurearray[1]],
        //     position: "outer-middle"
        //   }
        // },
        y: {
          
          //  padding:50,
          tick: {
            outer: false,          
            format:
            measurearray[0].toLowerCase().indexOf("over")>=0 
            ? d3format.format(".0%")
            :measurearray[0].toLowerCase().indexOf("price")>=0 ?d3format.format("$,")
            :measurearray[0].toLowerCase().indexOf("monthstosell")>=0 ?d3format.format(".1f"):""
          },
          // label: {
          //   text: labels[measurearray[0]],
          //   position: "outer-middle"
          // }
        },
        x: {
          tick: {
           // type: 'timeseries',
            multiline: false,
            outer: false,
           // values: [0,2,4,6,8,10,12,14,16,18,20,22,24,26,28,30,32,64,128],          
           culling: {
            max:40
           }  ,
           rotate: -45           
          },
//height:500, 
          type: "category",
         
        }
      },
      grid: {
        y: {
          show: true
        }
      },

      zoom: {
        enabled: false
      },
      bar: {
        space: 0.1,
        width: {
          //  ratio: 0.5,// this makes bar width 50% of length between ticks
        }
        //space:.25
        // or
        //width: 100 // this makes bar width 100px
      }
    });
  }



  _updateSingleAxesChart(data1, ws, assets) {
    var measurearray = ws.measure.split(",");
    var masterarray = [];
    var periodarray = [];

    var SFarrayM1 = ["SFHM1"];
    var CIarrayM1 = ["C/TM1"];

    var periodarrayasc = [];
    var periodarrayformatted = ["Period"];
    var percentsp=[];
    data1.forEach(function(record) {
      if(Number(record.AvgSaleOverListPrice)!=0 && Number(record.AvgSaleOverListPrice)<1.3)
        {
          percentsp.push(Number(record.AvgSaleOverListPrice));
        }
      if (periodarrayasc.indexOf(record.Period) === -1) {
        periodarrayasc.push(record.Period);
      }
    });
    periodarrayasc.reverse().forEach(function(x) {
      periodarray.push(x);
    });


    periodarray.forEach(function(periodrecord) {
    let filtereddata1=data1.filter(rec=>rec.Period===periodrecord)
  

    filtereddata1.forEach(function(record) { 
      if(filtereddata1.length==2){     
      record.Class.toLowerCase() == "residential - single family" 
          ? SFarrayM1.push(record[measurearray[0].toString()]) 
          : record.Class.toLowerCase() == "residential - common interest" 
            ? CIarrayM1.push(record[measurearray[0].toString()]==null?0:record[measurearray[0].toString()]) 
            : "";
      }else
      {
        record.Class.toLowerCase() == "residential - single family" 
        ? SFarrayM1.push(record[measurearray[0].toString()])  &&
        CIarrayM1.push(null) 
        : record.Class.toLowerCase() == "residential - common interest" 
          ? CIarrayM1.push(record[measurearray[0].toString()])  &&
          SFarrayM1.push(null) 
          : "";
        
      }
   
      });
  
    
    });
  
var ct="bar";
    if (ws.periodtype.toLowerCase() == "month") {    
      ct="line";
     
      var monthnames = {
        "01": "Jan",
        "02": "Feb",
        "03": "Mar",
        "04": "Apr",
        "05": "May",
        "06": "Jun",
        "07": "Jul",
        "08": "Aug",
        "09": "Sep",
        "10": "Oct",
        "11": "Nov",
        "12": "Dec"
      };
      periodarray.forEach(function(periodraw) {
        periodarrayformatted.push(
          monthnames[periodraw.substring(5)] + " " + periodraw.substring(2, 4)
        );
      });
    } else if (ws.periodtype.toLowerCase() == "quarter" ) {
      ct="area";
      if (ws.measure.toLowerCase().indexOf("monthstosell") >=0|| ws.measure.toLowerCase().indexOf("over")>=0 || ws.measure.toLowerCase().indexOf("dom")>=0)
        {
          ct="line";
        }
      
      periodarray.forEach(function(periodraw) {
        periodarrayformatted.push(periodraw);
      });
    } else {
      periodarray.forEach(function(periodrecord) {
        periodarrayformatted.push(periodrecord);
      });
    }

    masterarray.push(periodarrayformatted);


    if(this.props.widgetselections.classtype.split(',').length==2 )
      {
        SFarrayM1.length > 1 ? masterarray.push(SFarrayM1) : "";
        CIarrayM1.length > 1 ? masterarray.push(CIarrayM1) : "";
          }
          else if(this.props.widgetselections.classtype.indexOf('Single Family')>=0)
      {       
        SFarrayM1.length > 1 ? masterarray.push(SFarrayM1) : "";}
    else if(this.props.widgetselections.classtype.indexOf('Common Interest')>=0)
      {
        CIarrayM1.length > 1 ? masterarray.push(CIarrayM1) : "";
      }







    let defaultcolors = [
      "RGB(0,130,202)",
      "RGB(246,178,33)",
      "RGB(255,102,0)",
      "RGB(28,63,148)",
    ];
    let mpcolors = [
      "RGB(28,63,148)",
      "RGB(255,102,0)",
     
     
    ];
    //let defaultcolors=[ 'RGB(126,159,26)', 'RGB(230,145,56)','RGB(0,0,0)', 'RGB(255,217,102)']
    let preferredcolors = [];
  
    // assets
    //   .filter(
    //     prefrow =>
    //       prefrow.AttributeKey.toLowerCase().includes("vprimcolor") ||
    //       prefrow.AttributeKey.toLowerCase().includes("vseccolor")
    //   )
    //   .forEach(function(pref) {
    //     preferredcolors.push(pref.AttributeValue);
    //   });
    // defaultcolors.forEach(function(defcol) {
    //   if (!preferredcolors.includes(defcol)) {
    //     preferredcolors.push(defcol);
    //   }
    // });
    Aculistc3.chart.internal.fn.getHorizontalAxisHeight = function (axisId) {
      var $$ = this, config = $$.config, h = 30;
      if (axisId === 'x' && !config.axis_x_show) { return 8; }
      if (axisId === 'x' && config.axis_x_height) { return config.axis_x_height; }
      if (axisId === 'y' && !config.axis_y_show) { 
          return config.legend_show && !$$.isLegendRight && !$$.isLegendInset ? 10 : 1; 
      }
      if (axisId === 'y2' && !config.axis_y2_show) { return $$.rotated_padding_top; }
      // Calculate x axis height when tick rotated
      if (axisId === 'x' && !config.axis_rotated && config.axis_x_tick_rotate) {
          h = 30 + $$.axis.getMaxTickWidth(axisId) * Math.cos(Math.PI * (90 - Math.abs(config.axis_x_tick_rotate)) / 180);
      }
      // Calculate y axis height when tick rotated
      if (axisId === 'y' && config.axis_rotated && config.axis_y_tick_rotate) {
          h = 30 + $$.axis.getMaxTickWidth(axisId) * Math.cos(Math.PI * (90 - Math.abs(config.axis_y_tick_rotate)) / 180);
      }
      return h + ($$.axis.getLabelPositionById(axisId).isInner ? 0 : 10) + (axisId === 'y2' ? -10 : 0);
  };

    const chart = Aculistc3.generate({
     // padding: { top: 50, left: 50, bottom: 20 },
      bindto: "#" + this.props.id,
      position: "inset",
      // padding: {
      //   top: 40
      // },

      data: {
        types: {
          SFHM1: ct,
          "C/TM1": ct
        },
        x: "Period",
        columns: masterarray,
        axes: {
          SFHM1: "y",
          "C/TM1": "y"
        },
        labels: "true",
        names: {
          SFHM1: "Single Family Home " + legendlabels[measurearray[0]],
          "C/TM1": "Condo/Townhome " + legendlabels[measurearray[0]]
  
      }
    },
      point: {
        r: 0
      },
      color: {
        pattern:measurearray[0].toLowerCase().indexOf("medsaleprice")>=0?mpcolors:defaultcolors
      },
      axis: {
        y: {
          //  padding:50,
          tick: {
            outer: false,          
            format:
            measurearray[0].toLowerCase().indexOf("over")>=0 ?d3format.format(".0%")    :
            measurearray[0].toLowerCase().indexOf("price")>=0 || measurearray[0] == "SaleVolume"
            ? d3format.format("$,") :measurearray[0].toLowerCase().indexOf("count") >=0
            ? d3format.format(',')        
            :measurearray[0].toLowerCase().indexOf("monthstosell")>=0 ?d3format.format(".1f"):"",
                
            //values:measurearray[0].toLowerCase().includes("over")?[.95,.96,.96,.97,.98,.99,1.00,1.01,1.02,1.03,1.04,1.05]:'',
          },
          max: measurearray[0].toLowerCase().indexOf("over")>=0?Math.max(...percentsp):'',
          min: measurearray[0].toLowerCase().indexOf("over")>=0?Math.min(...percentsp):'',
        //  max: measurearray[0].toLowerCase().includes("over")?1.2:'',
        //  min: measurearray[0].toLowerCase().includes("over")?.95:'',
          padding: {top:0, bottom:0},
          label: {
            text: labels[measurearray[0]],
            position: "outer-middle"
          }
        },
        x: {
          tick: {
           // type: 'timeseries',
            multiline: false,
            outer: false,
          //  values: [0,2,4,6,8,10,12,14,16,18,20,22,24,26,28,30,32,64,128],          
           culling: false,
           rotate: -45     ,
           culling: {
            max:40
        }       
          },
//height:500, 
          type: "category",
         
        },
      },
      grid: {      
        // focus:{show:true},
        y: {
          show: true
        }
      },

      zoom: {
        enabled: false
      },
      bar: {
        space: 0.1,
        width: {
          //  ratio: 0.5,// this makes bar width 50% of length between ticks
        }
        //space:.25
        // or
        //width: 100 // this makes bar width 100px
      }
    });
  }

  render() {
    return (
      <div id={this.props.id} className={this.props.chartclasses} >
        Error
      </div>
    );
  }
}

//export default MarketTrends;



// WEBPACK FOOTER //
// ./src/MarketTrends.js